import 'css-chunk:src/components/widgets/Notice/FeatureNotice.scss';export default {
  "FeatureNotice": "_FeatureNotice_1y9ej_1"
};